// "Log in with Twitch", without a backend session: Twitch's implicit flow. We send the
// user to Twitch with no scopes, Twitch sends them back to the site's root with an access
// token in the URL fragment, and our functions ask Twitch who the token belongs to
// (netlify/lib/twitch.mjs). The token stays in this browser. Site-wide it only fills in
// the "Who are you?" username (twitchSync.js); the draft pool also sends it with every
// write, to prove who's submitting.
//
// The redirect is always the site root (origin + '/'), so the Twitch app only needs one
// redirect URL per host; where the user was is kept in sessionStorage and restored.

// The site's Twitch app (dev.twitch.tv; public client, so this isn't a secret). Its
// redirect URLs list each host's root: wiznaib.us, the staging deploy, localhost:1234.
export const TWITCH_CLIENT_ID = 'b8uml5xrghfnwaywb5phsrl34j8xxm';

const TOKEN = 'wiznaibus.twitch.v1';      // { token, login }
const PENDING = 'wiznaibus.twitch.pending';  // { state, back }

const read = (store, k) => { try { return JSON.parse(store.getItem(k)) || null; } catch (e) { return null; } };
const write = (store, k, v) => { try { if (v == null) store.removeItem(k); else store.setItem(k, JSON.stringify(v)); } catch (e) { /* storage off */ } };

export const redirectUri = () => window.location.origin + '/';

export function startTwitchLogin(clientId = TWITCH_CLIENT_ID) {
  const state = Math.random().toString(36).slice(2) + Date.now().toString(36);
  write(sessionStorage, PENDING, { state, back: window.location.href });
  const q = new URLSearchParams({ client_id: clientId, redirect_uri: redirectUri(), response_type: 'token', scope: '', state, force_verify: 'true' });
  window.location.assign('https://id.twitch.tv/oauth2/authorize?' + q);
}

// Called first thing on boot (main.js). If Twitch just sent us back, keep the token and
// return to where the user was; true means "navigating away, don't start the app".
export function finishTwitchLogin() {
  const h = window.location.hash;
  if (!/(^#|&)(access_token|error)=/.test(h)) return false;
  const p = new URLSearchParams(h.slice(1));
  const pending = read(sessionStorage, PENDING);
  write(sessionStorage, PENDING, null);
  if (!pending || p.get('state') !== pending.state) {   // not ours: just drop the fragment
    history.replaceState(null, '', window.location.pathname + window.location.search);
    return false;
  }
  if (p.get('access_token')) write(localStorage, TOKEN, { token: p.get('access_token'), login: '' });
  window.location.replace(pending.back || '/');
  return true;
}

export const twitchAuth = () => read(localStorage, TOKEN);
export const setTwitchLogin = (login) => { const a = twitchAuth(); if (a) write(localStorage, TOKEN, { ...a, login }); };
export const twitchLogout = () => write(localStorage, TOKEN, null);

// The logged-in Twitch name, asking Twitch (through our function) once per browser. ''
// when not logged in; an expired or revoked token is forgotten.
export async function whoami() {
  const a = twitchAuth();
  if (!a) return '';
  if (a.login) return a.login;
  try {
    const r = await fetch('/.netlify/functions/twitch-whoami', {
      method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify({ token: a.token }),
    });
    if (r.status === 401) { twitchLogout(); return ''; }
    const out = await r.json();
    if (out.login) setTwitchLogin(out.login);
    return out.login || '';
  } catch (e) { return ''; }   // offline, or the dev server (no functions): try again next load
}
